import PasswordValidationInput from './PasswordValidationInput';

export default PasswordValidationInput;
